import { render, staticRenderFns } from "./CollabCard.vue?vue&type=template&id=5b6c3983&scoped=true"
import script from "./CollabCard.vue?vue&type=script&lang=js"
export * from "./CollabCard.vue?vue&type=script&lang=js"
import style0 from "./CollabCard.vue?vue&type=style&index=0&id=5b6c3983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c3983",
  null
  
)

export default component.exports